module.exports = __webpack_public_path__ + "static/herobgxs-ded1e211b3c57168a5db3951025771f3.png";